export default __webpack_public_path__ + "static/media/Icon_battle_fields.b37043dd.svg";